import  classes  from './App.module.css';
import Details from './Details';
function App() {
  let frontendlink = "https://www.frontendmentor.io?ref=challenge";
  let blankurl = "";
  return (
    <div className={classes.App}>
        <div className={classes.Container}>
          <img src='./image-product-desktop.jpg' alt="Product" className={classes.DeskImg} />
          <img src='./image-product-mobile.jpg' alt='Product' className={classes.MobaImg} />
          <Details />
        </div>
        <div className="attribution" hidden={true}>
    Challenge by <a href={frontendlink} target="_blank" rel="noreferrer">Frontend Mentor</a>. 
    Coded by <a href={blankurl}>Amit Dhakal</a>.
  </div>
    </div>
  );
}

export default App;